import type { RoleGetListInput } from '../../service/types/role.param'

export const roleQueryKeys = {
  all: ['roles'] as const,
  lists: () => [...roleQueryKeys.all, 'list'] as const,
  list: (filters: RoleGetListInput) => [...roleQueryKeys.lists(), filters] as const,
  details: () => [...roleQueryKeys.all, 'detail'] as const,
  detail: (id: number) => [...roleQueryKeys.details(), id] as const,
  permissionsTree: () => [...roleQueryKeys.all, 'permissions-tree'] as const,
  combobox: () => [...roleQueryKeys.all, 'combobox'] as const,
  tabs: () => [...roleQueryKeys.all, 'tabs'] as const,
  menu: () => [...roleQueryKeys.all, 'menu'] as const,
}
